import { ShoppingCartOutlined } from '@ant-design/icons';

import ProductPage from 'src/pages/ProductPage/ProductPage';

import { SiteMap } from './index';

export const productRoutes: SiteMap = {
  product: {
    title: '상품 관리',
    page: ProductPage,
    icon: <ShoppingCartOutlined />,
    key: '/product',
    children: [
      {
        label: '상품 목록',
        icon: null,
        key: '/product/list',
      },
      {
        label: '상품 일괄 수정',
        icon: null,
        key: '/product/table-selector',
      },
      {
        label: '상품 가격 맵핑',
        icon: null,
        key: '/product/price-mapping',
      },
      {
        label: '경매 가격 동향',
        icon: null,
        key: '/product/market-price-trend',
      },
      {
        label: '경쟁사 가격 동향',
        icon: null,
        key: '/product/competitor-price-trend',
      },
      {
        label: '선주문 상품 관리',
        icon: null,
        key: '/product/pre-order',
      },
    ],
  },
};
